export default {"src":"/_next/static/media/water_skiing.177b1524.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};